import * as bootstrap from 'bootstrap';

const SELECTOR = '[data-data-table-tooltip-popover]';
const INITIALIZED_FLAG = 'dataTableTooltipPopoverInitialized';

function applyPopoverMaxWidth(element) {
    if (!(element instanceof HTMLElement)) {
        return;
    }

    const maxWidth = getComputedStyle(element).getPropertyValue('--data-table-tooltip-max-width').trim();
    if (!maxWidth) {
        return;
    }

    const popoverId = element.getAttribute('aria-describedby');
    const popoverElement = popoverId ? document.getElementById(popoverId) : null;
    if (!popoverElement) {
        return;
    }

    popoverElement.style.setProperty('--data-table-tooltip-max-width', maxWidth);
}

function initDataTableTooltipPopovers(root = document) {
    if (!bootstrap || typeof bootstrap.Popover !== 'function') {
        return;
    }

    const elements = [];

    if (root instanceof Element && root.matches(SELECTOR)) {
        elements.push(root);
    }

    if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(SELECTOR).forEach((element) => elements.push(element));
    }

    elements.forEach((element) => {
        if (!(element instanceof HTMLElement) || element.dataset[INITIALIZED_FLAG] === '1') {
            return;
        }

        const content = (element.getAttribute('data-popover-text') || '').trim();
        if (!content) {
            return;
        }

        if (!element.hasAttribute('tabindex')) {
            element.setAttribute('tabindex', '0');
        }

        new bootstrap.Popover(element, {
            trigger: 'hover focus',
            placement: 'bottom',
            fallbackPlacements: ['top'],
            container: 'body',
            content,
            customClass: 'data-table__tooltip-popover',
            sanitize: true
        });

        element.addEventListener('shown.bs.popover', () => {
            applyPopoverMaxWidth(element);
        });

        element.dataset[INITIALIZED_FLAG] = '1';
    });
}

function initDataTableTooltipPopoverObserver() {
    if (typeof window === 'undefined' || window.__sppkDataTableTooltipPopoverObserver) {
        return;
    }

    const start = () => {
        if (!document.body || window.__sppkDataTableTooltipPopoverObserver) {
            return;
        }

        initDataTableTooltipPopovers(document);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (!(node instanceof Element)) {
                        return;
                    }

                    initDataTableTooltipPopovers(node);
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
        window.__sppkDataTableTooltipPopoverObserver = observer;
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
        return;
    }

    start();
}

if (typeof window !== 'undefined') {
    window.initDataTableTooltipPopovers = initDataTableTooltipPopovers;
}

initDataTableTooltipPopoverObserver();

export default initDataTableTooltipPopovers;
